import React from "react";
import '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faRobot,
  faMicrochip,
  faCogs,
  faTools,
  faCamera,
  faBrain,
  faSatellite,
  faCube,
  faNetworkWired
} from '@fortawesome/free-solid-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const expertiseData = [
  {
    icon: faRobot,
    title: "Robotics & Autonomous Systems",
    description: "Design, control, and simulation of autonomous mobile robots (AMR), swerve drive platforms, drones, and ROS1/ROS2 control frameworks.",
    labels: [
      "ROS1",
      "ROS2",
      "AMR",
      "Swerve Drive",
      "TurtleBot3",
      "ArduPilot",
      "Mission Planner",
      "Crazyflie Quadrotors",
      "Gazebo",
      "RViz",
      "Twist Multiplexing",
      "Teleoperation",
      "Robo Programming"
    ]
  },
  {
    icon: faSatellite,
    title: "Navigation, SLAM & Positioning",
    description: "High-precision autonomous navigation, spatial environment mapping, obstacle avoidance, and field GNSS RTK rover positioning.",
    labels: [
      "GNSS-RTK",
      "SLAM",
      "LiDAR",
      "D* Path Planning",
      "RRT & PRM",
      "Costmap Planning",
      "Mapping & Navigation",
      "Sensor Fusion",
      "Autonomous Navigation",
      "Rover"
    ]
  },
  {
    icon: faCamera,
    title: "Motion Capture & Computer Vision",
    description: "Real-time closed-loop motion tracking, depth camera perception, multispectral aerial monitoring, and computer vision systems.",
    labels: [
      "Qualisys Motion Capture",
      "Computer Vision",
      "Intel RealSense",
      "Multispectral Camera",
      "Motion Analysis",
      "Live Video Streaming"
    ]
  },
  {
    icon: faBrain,
    title: "Control Systems, Kinematics & AI",
    description: "Mathematical modeling of 3-DOF manipulators, computed torque control, state feedback, and deep reinforcement learning algorithms.",
    labels: [
      "Robot Kinematics & Dynamics",
      "3-DOF Manipulator",
      "Computed Torque Control",
      "Deep Reinforcement Learning (TD3)",
      "State Feedback Control",
      "MATLAB",
      "Robotics Toolbox",
      "AI for Robotics"
    ]
  },
  {
    icon: faMicrochip,
    title: "Embedded Systems & Hardware",
    description: "Low-level C/C++ & Python programming, microcontroller interfacing, sensor/actuator integration, and digital electronics.",
    labels: [
      "C/C++",
      "Python",
      "ESP32",
      "Arduino",
      "LEGO EV3",
      "Microcontroller Interfacing",
      "Digital Electronics",
      "Sensors & Actuators"
    ]
  },
  {
    icon: faNetworkWired,
    title: "IoT & Wireless Communication",
    description: "Industry 4.0 IoT architecture, wireless telemetry, cloud data dashboards, and hardware communication protocols.",
    labels: [
      "Industry 4.0",
      "Blynk",
      "ThingSpeak",
      "WiFi",
      "BLE",
      "Technomatrix",
      "Communication Protocols",
      "Wireless Communication"
    ]
  },
  {
    icon: faCogs,
    title: "Industrial Automation & Simulation",
    description: "Offline robot programming, industrial manipulator simulation, PLC logic, automation wiring, and IIoT production monitoring.",
    labels: [
      "RoboDK",
      "MotoSim",
      "WPL Soft",
      "Industrial Control Systems",
      "Process Automation",
      "IIoT for Automation",
      "Automation Wiring",
      "Electrical Machines"
    ]
  },
  {
    icon: faTools,
    title: "Electronics & PCB Design",
    description: "Circuit design, industrial electrical panel design, PCB layout design, and electronic device prototyping.",
    labels: [
      "PCB Design",
      "Proteus",
      "Electrical Panel Design",
      "Circuit Theory"
    ]
  },
  {
    icon: faCube,
    title: "CAD, Prototyping & Software",
    description: "3D CAD modeling, additive manufacturing, custom desktop GUI software development, and cybersecurity.",
    labels: [
      "Fusion 360",
      "3D Printing",
      "Rapid Prototyping",
      "GUI Development",
      "Python for ML",
      "Cybersecurity"
    ]
  }
];

function Expertise() {
  return (
    <div className="container" id="expertise">
      <div className="skills-container">
        <h1>Expertise</h1>
        <div className="skills-grid">
          {expertiseData.map((section, index) => (
            <div className="skill" key={index}>
              <FontAwesomeIcon icon={section.icon} size="3x" />
              <h3>{section.title}</h3>
              <p>{section.description}</p>
              <div className="flex-chips">
                <span className="chip-title">Skills:</span>
                {section.labels.map((label, i) => (
                  <Chip key={i} className='chip' label={label} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Expertise;
